var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellPlus = function SvgBellPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.029 9.462c0-2.781-1.628-5.51-4.603-6.174a1.432 1.432 0 0 0-2.85.008c-2.922.687-4.54 3.472-4.54 6.265v7.455H4.002v1h8.503v-1H7.037V9.561c0-2.83 1.85-5.426 4.962-5.426 3.197 0 5.03 2.544 5.03 5.327V14h1zM11.999 21q.262 0 .505-.064v1.022a3.008 3.008 0 0 1-3.513-2.965h1A2.01 2.01 0 0 0 11.999 21m2.513-1.507h2.492V22h1v-2.507h2.505v-1h-2.505V16h-1v2.493h-2.492z"
  })));
};
export default SvgBellPlus;